/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class t{constructor(){this.pan=0,this.rotate=0,this.zoom=0,this.fov=0,this.zoomOffset=0}}export{t as InterpolateComponents};
